module.exports = __webpack_public_path__ + "img/light_grey.0bb61ada.jpg";